import React, { Ref } from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './form-select-trigger.style';
import { Size } from './types';

export type FormSelectTriggerProps = {
  id?: string;
  isPlaceholder?: boolean;
  noBorders?: boolean;
  size?: Size;
  inheritColor?: boolean;
  noOverflow?: boolean;
  onClick?: () => void;
  triggerRef?: Ref<HTMLButtonElement>;
  // Rendered in the floating end slot; defaults to the open-menu chevron.
  endAdornment?: React.ReactNode;
  children: React.ReactNode;
};

export const FormSelectTrigger: React.FC<FormSelectTriggerProps> = ({
  id,
  isPlaceholder,
  noBorders,
  size = Size.Medium,
  inheritColor,
  noOverflow,
  onClick,
  triggerRef,
  endAdornment,
  children,
}) => (
  <Styled.Container>
    <Styled.Button
      ref={triggerRef}
      id={id}
      type="button"
      onClick={onClick}
      $isPlaceholder={!!isPlaceholder}
      $noBorders={!!noBorders}
      $size={size}
      $inheritColor={!!inheritColor}
      $noOverflow={!!noOverflow}
    >
      {children}
    </Styled.Button>
    <Styled.InteractionContainer $inheritColor={!!inheritColor} $size={size}>
      {endAdornment ?? (
        <Styled.IconContainer onClick={onClick}>
          <Icon icon={ChevronLeft} />
        </Styled.IconContainer>
      )}
    </Styled.InteractionContainer>
  </Styled.Container>
);
